import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ToolTip from '../../modals/ToolTip';

const Notification = () => {
  const isNotification = useSelector(
    (state) => state.sharedData.isNotification
  );

  return (
    <React.Fragment>
      <li className="nav-item dropdown no-arrow mx-1 eep_notification_li">
        <Link
          className="nav-link dropdown-toggle"
          id="alertsDropdown"
          role="button"
          to="/app/notifications"
        >
          <ToolTip
            title="Notifications"
            arrow
            placement="top-end"
            backgroundColor="#82889B"
            color="#FFFFFF"
            fontSize="12px"
          >
            <div className="position-relative">
              <img
                alt=""
                src={process.env.PUBLIC_URL + `/images/notification.svg`}
              />
              {/* <span className="badge badge-danger badge-counter">0</span> */}
              {Object.keys(isNotification).length > 0 &&
                isNotification.filter((e) => e.seen === false).length > 0 && (
                  <span className="notification-highlight"></span>
                )}
            </div>
          </ToolTip>
        </Link>
      </li>
    </React.Fragment>
  );
};
export default Notification;
